import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom'; // YENİ: Portal için import
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';
import './AdminModals.css';
import CountryCodePicker from '../CountryCodePicker';
import TimezoneSwitcher from '../TimezoneSwitcher';
import { timezones } from '../../data/timezones';
const API_URL = process.env.REACT_APP_API_URL;
const AddNewUserModal = ({ isOpen, onClose, onUserAdded }) => {
    const { t } = useTranslation();
    const { token } = useAuth();
  
    const [formData, setFormData] = useState({
        firstName: '', lastName: '', email: '', password: '', role: 'customer', status: 'active',
        countryCode: '+90', phone: '', timezone: 'Europe/Istanbul',
        mainLanguage: '', country: '', city: '',
        languagePairs: [{ source: 'tr', target: 'en' }], expertises: ['general']
    });
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isTimezoneOpen, setIsTimezoneOpen] = useState(false);
 
	// DÜZELTME: 'availableLanguages' artık bir state, 'useMemo' değil.
    const [availableLanguages, setAvailableLanguages] = useState([]);

    // DÜZELTME: Veri çekme mantığı kendi useEffect'ine taşındı.
   useEffect(() => {
        if (isOpen) {
            const fetchLanguages = async () => {
                try {
                    const response = await fetch(`${API_URL}/api/public/languages`);
                    if (!response.ok) throw new Error('Dil listesi alınamadı.');
                    const data = await response.json();
                    setAvailableLanguages(data);
                } catch (err) {
                    console.error(err);
                }
            };
            fetchLanguages();
        } else {
            // Modal kapandığında formu sıfırla
            setFormData({
                firstName: '', lastName: '', email: '', password: '', role: 'customer', status: 'active',
                countryCode: '+90', phone: '', timezone: 'Europe/Istanbul',
                mainLanguage: '', country: '', city: '',
                languagePairs: [{ source: 'tr', target: 'en' }], expertises: ['general']
            });
            setError('');
        }
    }, [isOpen]);


	const ALL_EXPERTISES = ['general', 'legal', 'medical', 'technical', 'academic'];

	const handleExpertiseChange = (expertise) => {
        setFormData(p => {
            const currentExpertises = p.expertises || [];
            const newExpertises = currentExpertises.includes(expertise)
              ? currentExpertises.filter(e => e !== expertise)
              : [...currentExpertises, expertise];
            return { ...p, expertises: newExpertises };
        });
    };
    const handleChange = (e) => setFormData(p => ({ ...p, [e.target.name]: e.target.value }));
    const handleCountryCodeChange = (code) => setFormData(p => ({ ...p, countryCode: code }));
    const handleAddPair = () => setFormData(p => ({ ...p, languagePairs: [...p.languagePairs, { source: 'tr', target: 'en' }] }));
    const handleRemovePair = (index) => setFormData(p => ({ ...p, languagePairs: p.languagePairs.filter((_, i) => i !== index) }));
    const handlePairChange = (index, field, value) => {
        const newPairs = [...formData.languagePairs];
        newPairs[index][field] = value;
        setFormData(p => ({ ...p, languagePairs: newPairs }));
    };
    const handleTimezoneChange = (tz) => setFormData(p => ({ ...p, timezone: tz }));
    
    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(''); setIsLoading(true);
        try {
            const response = await fetch(`${API_URL}/api/admin/users`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                body: JSON.stringify(formData)
            });
            const data = await response.json();
            if (!response.ok) throw new Error(t(data.messageKey) || t('error_user_create'));
            onUserAdded();
        } catch (err) {
            setError(err.message);
        } finally {
            setIsLoading(false);
        }
    };
    
    if (!isOpen) return null;

    // DÜZELTME: Tüm JSX, ReactDOM.createPortal() içine alındı.
    return ReactDOM.createPortal(
	<>
        <div className="admin-modal-overlay" onClick={onClose}>
            <div className="admin-modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="admin-modal-header">
                    <h3>{t('add_new_user')}</h3>
                    <button onClick={onClose} className="close-btn">&times;</button>
                </div>
                <form onSubmit={handleSubmit} className="admin-modal-form">
                    <div className="form-row-auth">
                        <div className="form-group-auth floating-label half-width"><input id="admin-firstName" name="firstName" type="text" onChange={handleChange} required placeholder=" " /><label htmlFor="admin-firstName">{t('first_name')}</label></div>
                        <div className="form-group-auth floating-label half-width"><input id="admin-lastName" name="lastName" type="text" onChange={handleChange} required placeholder=" " /><label htmlFor="admin-lastName">{t('last_name')}</label></div>
                    </div>
                    <div className="form-group-auth floating-label"><input id="admin-email" name="email" type="email" onChange={handleChange} required placeholder=" " /><label htmlFor="admin-email">{t('email_address')}</label></div>
                    <div className="form-group-auth floating-label"><input id="admin-password" name="password" type="password" onChange={handleChange} required placeholder=" " /><label htmlFor="admin-password">{t('password')}</label></div>
                    <div className="form-row-auth">
                        <div className="form-group-auth phone-code"><CountryCodePicker selectedCode={formData.countryCode} onCodeChange={handleCountryCodeChange} /></div>
                        <div className="form-group-auth floating-label phone-number"><input name="phone" type="tel" value={formData.phone} onChange={handleChange} placeholder=" " /><label htmlFor="admin-phone">{t('phone')}</label></div>
                    </div>
                    <div className="form-group-auth">
                        <label className="static-label">{t('role')}</label>
                        <select name="role" value={formData.role} onChange={handleChange}><option value="customer">{t('role_customer')}</option><option value="translator">{t('role_translator')}</option><option value="support">{t('role_support')}</option><option value="admin">{t('role_admin')}</option></select>
                    </div>
                    {formData.role === 'translator' && (
                        <>
						<div className="form-group-auth floating-label">
                                    <input id="admin-mainLanguage" name="mainLanguage" type="text" value={formData.mainLanguage} onChange={handleChange} placeholder=" " />
                                    <label htmlFor="admin-mainLanguage">{t('main_language')}</label>
                                </div>
                                <div className="form-row-auth">
                                    <div className="form-group-auth floating-label half-width">
                                        <input id="admin-country" name="country" type="text" value={formData.country} onChange={handleChange} placeholder=" " />
                                        <label htmlFor="admin-country">{t('country')}</label>
                                    </div>
                                    <div className="form-group-auth floating-label half-width">
                                        <input id="admin-city" name="city" type="text" value={formData.city} onChange={handleChange} placeholder=" " />
                                        <label htmlFor="admin-city">{t('city')}</label>
                                    </div>
                                </div>
                             <div className="form-group-auth">
        <label>{t('local_timezone')}</label>
       
        <div className="timezone-display-input" onClick={() => setIsTimezoneOpen(true)}>
          {formData.timezone}
        </div>
      </div>
							<div className="form-group-auth">
                                <label className="static-label">{t('expertise_area')}</label>
                                <div className="checkbox-grid-modal">
                                    {ALL_EXPERTISES.map(exp => (
                                        <label key={exp} className="chip-checkbox-modal">
                                            <input type="checkbox" checked={formData.expertises.includes(exp)} onChange={() => handleExpertiseChange(exp)} />
                                            <span>{t(exp)}</span>
                                        </label>
                                    ))}
                                </div>
                            </div>
                            <div className="form-group-auth">
                                <label className="static-label">{t('language_pairs')}</label>
                                {formData.languagePairs.map((pair, index) => (
                                    <div className="lang-pair-row-modal" key={index}>
                                       <select value={pair.source} onChange={(e) => handlePairChange(index, 'source', e.target.value)}>
                                {availableLanguages.map(lang => <option key={lang.code} value={lang.code}>{lang.name}</option>)}
                            </select>
                            <span>&rarr;</span>
                            <select value={pair.target} onChange={(e) => handlePairChange(index, 'target', e.target.value)}>
                                {availableLanguages.map(lang => <option key={lang.code} value={lang.code}>{lang.name}</option>)}
                            </select>
                            <button type="button" onClick={() => handleRemovePair(index)} className="remove-pair-btn">&times;</button>
                        </div>
                    ))}
                    <button type="button" onClick={handleAddPair} className="add-pair-btn-modal">+ {t('add_pair')}</button>
                </div>
            </>
        )}
                   
                    {error && <p className="auth-error">{error}</p>}
                    <div className="admin-modal-footer">
                        <button type="button" onClick={onClose} className="btn-secondary">{t('cancel')}</button>
                        <button type="submit" className="cta-button" disabled={isLoading}>{isLoading ? t('creating...') : t('create_user')}</button>
                    </div>
         </form>
                </div>
            </div>
            <TimezoneSwitcher 
                isOpen={isTimezoneOpen} 
                onClose={() => setIsTimezoneOpen(false)}
                timezones={timezones}
                selectedTimezone={formData.timezone}
                onTimezoneChange={handleTimezoneChange}
            />
        </>,
        document.getElementById('modal-root')
    );
};

export default AddNewUserModal;